// src/features/orders/components/OrderStatusBadge.tsx
import clsx from 'clsx';
import type { OrderStatus } from '../types/orders.types';

// Pure design-token references — no raw Tailwind palette colors.
// Colors come from the existing VaniaLabs ThemeEngine accent tokens.
const STATUS_CONFIG: Record<OrderStatus, { label: string; className: string }> = {
  completed: {
    label: 'موفق',
    className:
      'text-[var(--vania-accent-teal)] bg-[var(--vania-accent-teal)]/10 border-[var(--vania-accent-teal)]/20',
  },
  pending: {
    label: 'در انتظار',
    className:
      'text-[var(--vania-accent-amber)] bg-[var(--vania-accent-amber)]/10 border-[var(--vania-accent-amber)]/20',
  },
  cancelled: {
    label: 'لغو شده',
    className:
      'text-[var(--vania-accent-rose)] bg-[var(--vania-accent-rose)]/10 border-[var(--vania-accent-rose)]/20',
  },
};

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  const { label, className } = STATUS_CONFIG[status];

  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[11px] font-medium leading-none',
        className,
      )}
    >
      {label}
    </span>
  );
}
